export default __webpack_public_path__ + "static/media/pushup.0f929d7a.png";